<template>
  <div>
    <b-col
      cols="12"
      class="h5 text-morado-claro font-weight-normal px-0 text-center text-lg-left mt-1 gilmer"
      >{{ tituloVacantes }}</b-col
    >
    <TablaVacantes
      :niveles="nivelesSinEspecialidad ? nivelesSinEspecialidad : []"
      :nivelesEspecialidad="
        nivelesConEspecialidad ? nivelesConEspecialidad : {}
      "
    />
    <div
      class="small h6 text-morado-claro"
      v-if="etapaProceso != 'COMPLEMENTARIO'"
    >
      <p>
        * Vacantes referenciales, corresponden a una estimación basada en datos
        informados por el establecimiento.
      </p>
      <p>** Cantidad de estudiantes que postularon al curso el año anterior</p>
    </div>
    <div class="small h6 text-morado-claro" v-else>
      <p>
        * Vacantes disponibles, consideran el reporte de los establecimientos y
        los postulantes ya admitidos.
      </p>
      <p>** Cantidad de estudiantes que postularon al curso el año anterior</p>
    </div>
  </div>
</template>

<script>
import TablaVacantes from "@/components/ficha/derecha/TablaVacantes";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faRestroom,
  faMale,
  faFemale
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faRestroom, faMale, faFemale);
export default {
  components: {
    FontAwesomeIcon,
    TablaVacantes
  },
  props: {
    datos: {
      type: Object,
      requiered: true
    },
    sedeUnica: {
      type: Boolean,
      requiered: true
    }
  },
  data() {
    return {
      etapaProceso: localStorage.getItem("etapaVitrina") || "NORMAL",
      anioSiguiente: localStorage.getItem("anioSiguiente") || "default value"
    };
  },
  methods: {
    //calcula texto para intervalo vacantes
    textoVacantes: function(min, max) {
      return min + " a " + max + " vacantes";
    }
  },
  computed: {
    //computa texto para titulo vacantes
    tituloVacantes() {
      let string = this.sedeUnica
        ? `VACANTES AÑO ESCOLAR ${this.anioSiguiente}`
        : `VACANTES ${this.anioSiguiente} SEDE PRINCIPAL`;
      return string;
    },
    //separa niveles sin especialidad
    nivelesSinEspecialidad() {
      let niveles = [];
      this.datos.niveles
        ? (niveles = this.datos.niveles.filter(n => {
            if (n.glosaEspecialidad) {
              return false;
            } else {
              return true;
            }
          }))
        : (niveles = []);
      return niveles;
    },
    //separa niveles por especialidad
    nivelesConEspecialidad() {
      let diccionario = {};
      let niveles = [];

      let nivelesEspecialidad = this.datos.niveles
        ? this.datos.niveles.filter(n => {
            if (n.glosaEspecialidad) {
              return true;
            } else {
              return false;
            }
          })
        : [];
      nivelesEspecialidad.forEach(n => {
        n.glosaEspecialidad in diccionario
          ? diccionario[n.glosaEspecialidad].push(n)
          : (diccionario[n.glosaEspecialidad] = [n]);
      });
      return diccionario;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/derecha/VacantesPrincipal.vue